import axios from "axios";

function queryString(params = {}) {
    const query = Object.keys(params)
        .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== "")
        .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(params[key]))
        .join("&");
    return query ? "?" + query : "";
}

export function getDictTypePageFun(params) {
    return axios.get("/api/bms/dict/types" + queryString(params)).then((res) => res.data);
}

export function saveDictTypeFun(data) {
    return data.id
        ? axios.post("/api/bms/dict/types/update", data).then((res) => res.data)
        : axios.post("/api/bms/dict/types", data).then((res) => res.data);
}

export function updateDictTypeStatusFun(id, status) {
    return axios.post("/api/bms/dict/types/" + id + "/status/" + status).then((res) => res.data);
}

export function deleteDictTypeFun(id) {
    return axios.post("/api/bms/dict/types/" + id + "/delete").then((res) => res.data);
}

export function getDictItemPageFun(params) {
    return axios.get("/api/bms/dict/items" + queryString(params)).then((res) => res.data);
}

export function saveDictItemFun(data) {
    return data.id
        ? axios.post("/api/bms/dict/items/update", data).then((res) => res.data)
        : axios.post("/api/bms/dict/items", data).then((res) => res.data);
}

export function updateDictItemStatusFun(id, status) {
    return axios.post("/api/bms/dict/items/" + id + "/status/" + status).then((res) => res.data);
}

export function deleteDictItemFun(id) {
    return axios.post("/api/bms/dict/items/" + id + "/delete").then((res) => res.data);
}

export function getDictOptionsFun(type) {
    return axios.get("/api/bms/dict/options?type=" + encodeURIComponent(type)).then((res) => res.data);
}
